export default {
    unit: 8,
};
//# sourceMappingURL=spacing.js.map